import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
const ClientIncome = (props) => {
    const clientProjects = props.clientProjects;
    const [yearFilter, setYearFilter] = useState(new Date().getFullYear());

    // Group projects by month and year, then sum their paid amounts
    const incomeByMonth = {};
    clientProjects.forEach(project => {
        const local = new Date(project.due_date);
        const offset = local.getTimezoneOffset();
        const due_date = new Date(local.getTime() + offset * 60000);
        const monthYear = `${due_date.getMonth() + 1}-${due_date.getFullYear()}`;

        function convertCurrencyToDouble(currency) {
            const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
            return Number(normalizedCurrency);
        }

        const paidAmount = convertCurrencyToDouble(project.paid);

        if (!incomeByMonth[monthYear]) incomeByMonth[monthYear] = 0;
        incomeByMonth[monthYear] += paidAmount;
    });

    // Find the max income to scale colors
    const maxIncome = Math.max(...Object.values(incomeByMonth));

    return (
        <>
            <h4 className="uppercase text-sm">Income History</h4>
            <div className="hBar mt-[7px] mb-[10px]"></div>
            <div className="flex flex-col rounded-2xl bg-[#181818]">
                <div className="flex items-center self-end pt-3 pb-1  pr-1 text-xs">
                    <button onClick={()=>{setYearFilter(yearFilter-1)}}><ChevronLeft size={15}/></button>
                    {yearFilter}
                    <button onClick={()=>{setYearFilter(yearFilter+1)}}><ChevronRight  size={15}/></button>
                </div>
                <div className="flex flex-col gap-2 pb-5 px-3  text-sm">
                    {Object.keys(incomeByMonth).map(monthYear => {
                        const [month, year] = monthYear.split("-");
                        if (parseInt(year) !== yearFilter) return null;

                        const income = incomeByMonth[monthYear];
                        const intensity = maxIncome ? income / maxIncome : 0; // scale 0-1
                        const color = `rgba(34, 197, 94, ${intensity})`; // green with alpha based on income

                        return (
                            <div key={monthYear} className="flex flex-row justify-between">
                                <div className="flex flex-col items-center w-full">
                                    <span className="font-bold">
                                        {new Date(year, month - 1).toLocaleString('default', { month: 'long' })}
                                    </span>
                                    <span>${income.toFixed(2)}</span>
                                </div>
                                <div
                                    id="colorGrade"
                                    className="w-1 "
                                    style={{ backgroundColor: color }}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default ClientIncome;
